import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <motion.footer
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      viewport={{ once: true }}
      className="bg-gray-300 fixed bottom-0 w-full text-gray-400 py-1"
    >
      <div className="w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap justify-between gap-8">
          

          {/* Empty Column (Logo placeholder) */}
          <div>
            <div className="flex items-center space-x-2 mb-4"></div>
            <div className="flex space-x-4"></div>
          </div>

          {/* About */}
          <div>
            <Link to="/about" className="text-gray-900 text-lg font-semibold mb-4">About us</Link>
          </div>

          {/* Team */}
          <div>
           <Link to="/team" className="text-gray-900 text-lg font-semibold mb-4">Our Team</Link>
          </div>

          {/* Resources */}
          <div>
            <Link to="/resources" className="text-gray-900 text-lg font-semibold mb-4">Resources</Link>
          </div>

          {/* Contact — SAME layout, only responsive classes */}
          <div className="text-sm w-full lg:w-auto">
            <div className="flex flex-wrap lg:flex-nowrap">

              <h3 className="text-gray-900 text-lg font-semibold mr-3 mb-3 w-full lg:w-auto">
                Contact
              </h3>

              <div className="flex items-center mr-4 mb-3">
                <span className="mr-1">✉️</span>
                <span className="mr-1 text-gray-900">info@value.com</span>
              </div>

              <div className="flex items-center mr-4 mb-3">
                <span className="mr-1 text-gray-900">📞</span>
                <span className="text-gray-900">+250781234567</span>
              </div>

              <div className="flex items-center mr-4 mb-3">
                <span className="mr-1 text-gray-900">🏢</span>
                <div className="flex">
                  <span className="mr-1 text-gray-900">400</span>
                  <span className="mr-1 text-gray-900">KN</span>
                  <span className="mr-1 text-gray-900">276</span>
                  <span className="mr-1 text-gray-900">st</span>
                </div>
              </div>

            </div>
          </div>

          {/* Empty Column */}
          <div></div>
        </div>

        <div className=" -mt-3 text-sm text-center">
          <p className="text-gray-900">© {new Date().getFullYear()} Value. All rights reserved.</p>
        </div>
      </div>
    </motion.footer>
  );
}
